export default "__VITE_PUBLIC_ASSET__959445c0__"